<div class="requisition-popup-container">
    <!-- LOADER -->
    <div class="requisition-loader" *ngIf="loading()">
        <div class="loader-content">
            <div class="spinner"></div>

            <div class="loader-text">
                Loading tests...
            </div>
        </div>
    </div>
    <!-- HEADER -->
    <div class="requisition-header">

        <div class="header-left">

            <div class="heading">
                New Requisition
            </div>

            <div class="subheading">

                <mat-icon class="patient-icon">
                    person
                </mat-icon>

                <span class="patient-name">
                    {{ patientFullName }}
                </span>

                <span class="uhid" *ngIf="patientUHID">

                    | UHID : {{ patientUHID }}

                </span>

            </div>

        </div>

        <div class="header-right">

            <mat-form-field appearance="outline" class="template-field">

                <mat-label>
                    Template
                </mat-label>

                <mat-select [(value)]="templateName">

                    <mat-option *ngFor="let item of selectedTemplate" [value]="item">

                        {{ item }}

                    </mat-option>

                </mat-select>

            </mat-form-field>

            <button mat-icon-button color="warn" class="close-btn" (click)="closeDialog()">

                <mat-icon>
                    close
                </mat-icon>

            </button>
        </div>
    </div>
    <!-- SEARCH -->

    <div class="search-box-wrapper">

        <mat-icon>
            search
        </mat-icon>

        <input matInput placeholder="Search Test" [(ngModel)]="searchBox" (input)="onSearchChange(searchBox)">

    </div>
    <!-- TABS -->
    <mat-tab-group>

        <mat-tab label="All Tests">

            <div class="tests-wrapper">

                <div *ngFor="let section of filteredSectionWiseRequisitionTests">

                    <div class="section-title">
                        {{ section.section }}
                    </div>

                    <div *ngFor="let test of section.data" class="test-card"
                        [class.selected]="selectedTest.includes(test.name)" (click)="selectModalTestValue(test)">

                        {{ test.name }}

                    </div>

                </div>
                <div *ngIf="
    searchBox?.length >= 4 &&
    filteredSectionWiseRequisitionTests.length === 0" class="no-result">
                    No tests found
                </div>
            </div>

        </mat-tab>

        <mat-tab label="Packages">

            <div class="tests-wrapper">

                <div *ngFor="
                let key of objectKeys(filteredPackageWiseTests)
            " class="package-section">

                    <!-- PACKAGE HEADER -->

                    <div class="package-header">

                        <mat-checkbox [checked]="isPackageSelected(key)" (change)="getSelctedTest(key, $event)"
                            (click)="$event.stopPropagation()">
                        </mat-checkbox>

                        <span class="section-title">
                            {{ key }}
                        </span>

                    </div>


                    <!-- PACKAGE TESTS -->

                    <div *ngFor="
                    let obj of filteredPackageWiseTests[key]
                " class="test-card" [class.selected]="
                    isPackageTestSelected(
                        key,
                        obj.test
                    )
                " (click)="
                    selectPackageTestValue(obj)
                ">

                        {{ obj.test }}

                    </div>

                </div>
                <!-- NO RESULT -->

                <div *ngIf="
                searchBox?.trim().length >= 2 &&
                objectKeys(filteredPackageWiseTests).length === 0
            " class="no-result">

                    No packages/tests found

                </div>

            </div>

        </mat-tab>


    </mat-tab-group>

    <!-- SELECTED TESTS -->

    <div class="selected-tests-container">

        <div class="selected-title">

            Selected Tests

        </div>

        <div class="selected-tests-wrap">

            <div *ngFor="
        let item of selectedTest" class="test-chip">

                {{ item }}

                <span class="remove-chip" (click)="removeSelectedTest(item)">

                    ×

                </span>

            </div>

        </div>

    </div>

    <!-- COMMENTS -->

    <div class="comments-section">

        <textarea rows="4" placeholder="Comments" [(ngModel)]="comments" style="height: 20px;">

    </textarea>

    </div>

    <!-- FOOTER -->

    <div class="requisition-footer">

        <button class="cancel-btn" (click)="closeDialog()">

            Cancel

        </button>

        <button class="save-btn" (click)="saveAndShare()" [disabled]="isRequisitionsLoading">

            <mat-icon>
                {{ isRequisitionsLoading ? 'hourglass_top' : 'share' }}
            </mat-icon>

            {{ isRequisitionsLoading ? 'Please wait...' : 'Save & Share' }}

        </button>

    </div>

</div>